export const bulkUserCreation = `<div class="tile-container row">
<div class="col-4 offset-0">
    <div class="tile">
        <a class="import-guide-link" href='${process.env.PUBLIC_URL}/importGuides/bulkUserCreation/guidance/Bulk_User_Upload_MIG_v1.1.docx' download>
            <div class="tile-icon"><i class="fa fa-book" title="Guidance"></i></div>
            <h3 class="title text-content">Guidance</h3>
        </a>
    </div>
</div>
<div class="col-4 offset-0">
    <div class="tile">
        <a class="import-guide-link" href='${process.env.PUBLIC_URL}/importGuides/bulkUserCreation/template/Bulk_User_File_Import_Template.xlsx' download>
            <div class="tile-icon"><i class="fa fa-credit-card" title="Template"></i></div>
            <h3 class="title text-content">Template</h3>
        </a>
    </div>
</div>
</div>`;


// WEBPACK FOOTER //
// ./src/components/content/BulkUserCreation.ts